/* 🤖 this file was generated by svg-to-ts */
export const siriusTicket: {
  name: 'ticket';
  data: string;
} = {
  name: 'ticket',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 4.5A1.5 1.5 0 0 0 1.5 6v2.323a1.49 1.49 0 0 0 1.2 1.468 2.26 2.26 0 0 1 0 4.418 1.49 1.49 0 0 0-1.2 1.468V18A1.5 1.5 0 0 0 3 19.5h18a1.5 1.5 0 0 0 1.5-1.5v-2.323a1.49 1.49 0 0 0-1.2-1.468 2.26 2.26 0 0 1 0-4.418 1.49 1.49 0 0 0 1.2-1.468V6A1.5 1.5 0 0 0 21 4.5H3ZM8.25 6H3v2.321l.006.002a3.76 3.76 0 0 1 0 7.354L3 15.68V18h5.25V6Zm1.5 12V6H21v2.321l-.006.002a3.76 3.76 0 0 0 0 7.354l.006.002V18H9.75Z" fill="currentColor"/></svg>`
};
